export const PRIMARY_DOMAIN_TYPE = 'ROOT';
export const SUB_DOMAIN_TYPE = 'SUB';
export const RESPONSE_STATUS_TRUE = 'Y';
export const RESPONSE_STATUS_FALSE = 'N';
export const DOMAIN_STATUS_DISABLED = 3;
export const DOMAIN_STATUS_CANCEL_DISABLED = 4; // User cancelled subscription, domain disabled
export const DNS_ROOT = '@';
export const DNS_SHOULD_NOT_EXIST = 'SHOULD_NOT_EXIST';
export const DNS_UNKNOWN = 'UNKNOWN';
